//react
import React from 'react';

//redux
import { connect } from 'react-redux';

//firebase
import { db } from 'assets/firebase';

//algolia full text search
import { algolia } from 'assets/algolia';

// order
import { orders } from 'assets/orders';

// html parser
import Parser from 'html-react-parser';

//styles
import withStyles from "@material-ui/core/styles/withStyles";
import modalStyle from "assets/jss/material-kit-pro-react/modalStyle.jsx";

//core
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Table from "@material-ui/core/Table";
import TableRow from "@material-ui/core/TableRow";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import CircularProgress from '@material-ui/core/CircularProgress';
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import InputAdornment from "@material-ui/core/InputAdornment";

//components
import CustomTabs from "components/CustomTabs/CustomTabs.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import ConfirmDialog from "components/ConfirmDialog/ConfirmDialog.jsx";

// @material-ui/icons
import Edit from "@material-ui/icons/Edit";
import Receipt from "@material-ui/icons/Receipt";

import Add from "@material-ui/icons/AddShoppingCart";
import Download from "@material-ui/icons/CloudDownload";


function Transition(props) {
  return <Slide direction="down" {...props} />;
}

function dateConverter(UNIX_timestamp){
    var a = new Date(UNIX_timestamp * 1000);
    var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    var year = a.getFullYear();
    var month = months[a.getMonth()];
    var date = a.getDate();
    var time = month + ' ' + date + ' ' + year;
    return time;
}
  
class OrderDetails extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      modal: false,
      order: { items: [], notes: ""},
      address: { street:"", city:"", state:"" },
      addresses: [],
      tax: 0.00,
      addingNew: false,
      productIDQuery: "",
      productNameQuery: "",
      baselineOrder: {
        items: []
      },
      orderChanged: false,
      searchResults:[],
      searchInProgress: false,
      pricing:[],
      school:{},
      shipToAddress: { name:"", address:"", city:"", state:"", zip:""}
    };

    this.addNew = this.addNew.bind(this);
    this.searchProductNames = this.searchProductNames.bind(this);
  }

  handleClickOpen(modal) {

    console.log(this.props);
    
    this.setState({order: this.props.order}, () => {

      this.getBaselineOrder();
      this.getShippingAddress();
      
      if(this.state.order.tax) {
        this.setState({tax: this.state.order.tax});
      }

      var x = [];
      x[modal] = true;
      this.setState(x);
    });
  }

  handleClose(modal) {
    var x = [];
    x[modal] = false;
    this.setState(x);
  }
    
  trim(value, maxLength) {
    if(value.length > maxLength)
        return value.substring(0,maxLength) + "...";
    else
        return value;
  }

  getBaselineOrder() {

    var baselineOrder = {
      items: [],
      shippingAddressID: this.state.order.shippingAddressID
    }
    
    for(var i = 0; i < this.state.order.items.length; i++) {
      baselineOrder.items.push(
        {
          productID: this.state.order.items[i].productID, 
          qty: this.state.order.items[i].qty, 
          listPrice: this.state.order.items[i].listPrice
        }
      );
    }

    this.setState({baselineOrder});
  }

  checkOrderChanged() {
    
    var changed = false;

    var order = this.state.order;
    var baseline = this.state.baselineOrder;

    if(baseline.shippingAddressID !== order.shippingAddressID) {
      changed = true;
    } else if(baseline.items.length !== order.items.length) {
      changed = true;
    } else {
      for(var i = 0; i < baseline.items.length; i++) {
        var isFound = false;
        for(var j = 0; j < order.items.length; j++) {
          if(baseline.items[i].productID === order.items[j].productID) {
            isFound = true;
            
            if(baseline.items[i].qty !== order.items[j].qty ||
               baseline.items[i].listPrice !== order.items[j].listPrice) {
                changed = true;
            
                break;
              }
          }
        }
        if(!isFound) {
          changed = true;
          break;
        }
      }
    }

    this.setState({orderChanged: changed});
  }

  getShippingAddress() {

    db.getSchool(this.state.order.schoolID).then((school) => {
      console.log(school)

      this.setState({
        school: school,
        shipToAddress: {
        name: school.Name,
        address: school.Address,
        city: school.City,
        state: school.State,
        zip: school.PostalCode
      }}, () => {
        this.calculateTax();
      });
    });

  }

  showSyncProgressIndicator() {
    if(this.state.syncInProgress) {
      return "block";
    } else {
      return "none";
    }
  }
  
  showActionButtons() {
    if(!this.state.syncInProgress) {
      return "block";
    } else {
      return "none";
    }
  }

  getNotes() {
    var notes = this.state.order.notes;
    while(notes.indexOf('\n') > -1) {
      notes = notes.replace('\n','<br>')
    }
    
    return Parser(notes)
  }

  calculateTax() {

    this.calculateTotal();
  }

  updateOrder(property, value) {
    var x = this.state.order;
    x[property] = value;
    this.setState({order: x});
  }

  calculateTotal() {
 
    var x = this.state.order;

    var total = 0.00;
    for(var i = 0; i < x.items.length; i++) {

      if(!isNaN(x.items[i].qty) && !isNaN(x.items[i].listPrice)) {
        x.items[i].total = (Number(x.items[i].qty) * Number(x.items[i].listPrice)).toFixed(2);
      } else {
        x.items[i].total = 0.00;
      }
      total = (Number(total) + Number(x.items[i].total)).toFixed(2);
    }

    x.orderTotal = (Number(total) + Number(this.state.tax)).toFixed(2);
    this.setState({order: x}, () => {
      this.checkOrderChanged();
    });
  }

  addNew() {
    this.setState({addingNew: true});
  }

  showAddNew() {
    if(this.state.addingNew) {
      return "table-row";
    } else {
      return "none";
    }
  }

  showAddNewButton() {
    if(this.state.addingNew) {
      return "none";
    } else {
      return "block";
    }
  }

  addLineItem(item) {

    var x = this.state.order;
    x.items.push(item);
    this.setState({order: x});
  }

  updateLineItem(id, property, value) {
    var x = this.state.order;

    for(var i = 0; i < x.items.length; i++) {

      if(x.items[i].id === id)
        x.items[i][property] = value;
      }

    this.setState({order: x}, () => {
      this.calculateTax();
    });
  }

  deleteLineItem(id) {

    var x = this.state.order;

    for(var i = 0; i < x.items.length; i++) {

      if(x.items[i].id === id) {
        x.items.splice(i,1);
        break;
      }    
    }

    this.setState({order: x});
    this.calculateTax();
  }

  setSearchProductNamesTimer(query) {
    clearTimeout(this.searchProductNames);
    this.setState({productNameQuery: query}, () => {
        setTimeout(this.searchProductNames,1700);
    });
  }

  searchProductNames() {
    algolia.getProductsByName(this.state.productNameQuery).then(results => {
      this.setState({searchResults: results, searchInProgress: true });
    });
  }

  addProduct(product) {

    var lineItem = {
      id: product.id,
      name: product.name,
      listPrice: product.listPrice,
      qty: 1,
      productID: product.productID,
      total: Number(product.listPrice).toFixed(2)
    }

    this.addLineItem(lineItem);
    this.setState({addingNew: false, productNameQuery: "", searchInProgress: false, orderChanged: true});
  }

  showSearchResults() {
    if(this.state.searchInProgress) {
      return "block";
    } else {
      return "none";
    }
  }

  downloadPDF() {
    orders.getPDF(this.state.order);
  }

  showPOEditControls() {
    if(this.state.order.status === 'QUOTE') 
        return "block";
    else 
        return "none";
  }

  showPOLabel() {
    if(this.state.order.status !== 'QUOTE') 
        return "block";
    else 
        return "none";
  }

  render() {

    const { classes } = this.props;

    return (
      <div>
        
        <IconButton
          aria-label="Edit"
          onClick={() => this.handleClickOpen("modal")}>
          <Edit className={ classes.tableActionButtonIcon + " " + classes.edit } />
        </IconButton>
        <Dialog
          classes={{
            root: classes.center,
            paper: classes.modal
          }}
          maxWidth="md"
          fullWidth={true}
          open={this.state.modal}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => this.handleClose("modal")}
          aria-labelledby="modal-slide-title"
          aria-describedby="modal-slide-description">

          <DialogTitle
            id="classic-modal-slide-title"
            disableTypography
            className={classes.modalHeader}
            style={{backgroundColor:"#efefef"}} >

            <GridContainer direction="row">
              <GridItem xs={12} sm={12} md={6}>
                <h4 className={classes.modalTitle}>Order Details</h4>
              </GridItem>
              <GridItem xs={12} sm={12} md={6} style={{textAlign:"right"}}>
                
              </GridItem>
            </GridContainer>
          </DialogTitle>
          <DialogContent
            id="modal-slide-description"
            className={classes.modalBody}
            style={{backgroundColor:"#efefef"}}>
            <CustomTabs
              headerColor="success"
              tabs={[
                {
                  tabName: "General",
                  tabIcon: Receipt,
                  tabContent: (
                    
                      <GridContainer direction="row" style={{minHeight:"369px"}}>
                        <GridItem xs={3}>
                          <br />
                          <b>Order</b><div style={{fontWeight:400}}>
                            {this.state.order.id}<br />
                            <span style={{color:"#3fa31b"}}>{dateConverter(this.state.order.created)}</span>
                          </div>
                        </GridItem>
                        <GridItem xs={3}>
                          <br />
                          <b>Customer</b><div style={{fontWeight:400}}>
                            {this.state.school.Name}<br />
                            <span style={{color:"#3fa31b"}}>{this.state.order.userName}</span><br />
                          </div>
                        </GridItem>
                        <GridItem xs={3}>
                          <br />
                          <b>Shipping Address</b><div style={{fontWeight:400}}>
                          {this.state.shipToAddress.address}<br />
                          {this.state.shipToAddress.city} {this.state.shipToAddress.state} {this.state.shipToAddress.zip}
                          </div>
                        </GridItem>
                        <GridItem xs={3}>
                            <br />
                            <b>Purchase Order</b>
                            <div style={{display:this.showPOLabel(), fontWeight:400}}>    
                                {this.state.order.poNumber}
                            </div>
                          
                          <div style={{display:this.showPOEditControls(), marginTop:"-13px"}}>
                            <CustomInput
                                    labelText=""
                                    formControlProps={{
                                    fullWidth: true,
                                    className: classes.formControl
                                    }}
                                    inputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <Receipt className={classes.icon} />
                                        </InputAdornment>
                                    ),
                                    placeholder: "Purchase Order #"
                                    }}
                                    value={this.state.poNumber}
                                    onChange={this.poNumberChange}
                                />
                            </div>
                        </GridItem>
                        <GridItem xs={12}>
                          <br />
                          <Table className={classes.table}>
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{padding:"0px", width:"50px"}}></TableCell>
                                    <TableCell style={{padding:"3px"}}>
                                        Name
                                    </TableCell>
                                    <TableCell style={{padding:"3px", textAlign:'right'}}>
                                        Qty
                                    </TableCell>
                                    <TableCell style={{padding:"3px", textAlign:'right'}}>
                                        Price
                                    </TableCell>
                                    <TableCell style={{padding:"3px", textAlign:'right'}}>
                                        Total
                                    </TableCell>
                                    
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.state.order.items.map((value, index) => (
                                <TableRow key={index}>
                                    <TableCell style={{padding:"0px", width:"50px"}}>
                                      <Tooltip id="tooltip-top-start" title="Delete Line Item" placement="top" classes={{ tooltip: classes.tooltip }} >
                                        <ConfirmDialog header="Confirm Delete" description="Are you sure you want to delete this product? This action cannot be undone." confirmed={() => this.deleteLineItem(value.id)} />
                                      </Tooltip>
                                    </TableCell>
                                    <TableCell style={{padding:"3px"}}>
                                        {this.trim(value.name,54)}
                                    </TableCell>
                                    <TableCell style={{padding:"6px", width:"50px" }}>
                                      <input type="text" value={value.qty} placeholder="qty" 
                                        onChange={(e) => this.updateLineItem(value.id, "qty", e.target.value)} 
                                        style={{
                                          borderStyle:"none", 
                                          backgroundColor:"#efefef", 
                                          padding:"6px", 
                                          height:"21px", 
                                          borderRadius:"6px", 
                                          fontSize:"12px", 
                                          width:"90%", 
                                          textAlign:"right",
                                          marginLeft:"3px",
                                          marginRight:"3px",
                                        }} />
                                    </TableCell>
                                    <TableCell style={{padding:"6px", width:"80px", textAlign:'right' }}>
                                        ${value.listPrice}
                                    </TableCell>
                                    <TableCell style={{padding:"3px", textAlign:'right'}}>
                                        ${value.total}
                                    </TableCell>
                                </TableRow>
                                ))}
                                <TableRow style={{display:this.showAddNew()}}>
                                    <TableCell style={{padding:"0px", width:"50px"}}>
                                      <IconButton onClick={this.addLineItem} style={{color:"green"}}>
                                          <Add />
                                      </IconButton>
                                    </TableCell>
                                    <TableCell style={{padding:"3px"}}>
                                      <input type="text" placeholder="Product ID" className={classes.modalTextBox} style={{textAlign:"left"}}
                                          onChange={(e) => this.setSearchProductIDsTimer(e.target.value)} value={this.state.productIDQuery} />
                                    </TableCell>
                                    <TableCell style={{padding:"3px", position: "relative"}}>
                                      <input type="text" placeholder="Product Name" className={classes.modalTextBox} style={{textAlign:"left"}} 
                                        onChange={(e) => this.setSearchProductNamesTimer(e.target.value)} value={this.state.productNameQuery} />
                                      <div id="divSearchResults" style={{position: "absolute", height:"120px", width:"100%", backgroundColor:"#efefef", borderRadius:"6px", marginLeft:"6px", overflow:"auto", padding:"10px", fontSize:"11px", border:"solid 1px green", display:this.showSearchResults()}} >
                                        {this.state.searchResults.map((value, index) => (
                                          <div key={index} style={{cursor:"pointer", color:"232323"}} 
                                            onClick={() => this.addProduct(value)}><span style={{color:"green"}}>{value.productID}</span> - {this.trim(value.name,54)}</div>
                                        ))}
                                      </div>
                                    </TableCell>
                                    <TableCell style={{padding:"6px", width:"50px" }}>
                                      <input type="text" placeholder="Qty" className={classes.modalTextBox} style={{display:"none"}} />
                                    </TableCell>
                                    <TableCell style={{padding:"6px", width:"80px" }}>
                                      <input type="text" placeholder="Price" className={classes.modalTextBox} style={{display:"none"}} />
                                    </TableCell>
                                    <TableCell style={{padding:"3px", textAlign:'right'}}>
                                        $0.00
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>
                                        <IconButton onClick={this.addNew} style={{display:this.showAddNewButton()}}>
                                          <Add />
                                      </IconButton>
                                    </TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell style={{padding:"3px", textAlign:'right'}}>
                                        <b>Total</b>
                                    </TableCell>
                                    <TableCell style={{padding:"3px", textAlign:'right'}}>
                                        <b>${this.state.order.orderTotal}</b>
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                          </Table>
                        </GridItem>
                        <GridItem xs={12}>
                          <br />
                          <b>Notes</b><div style={{fontWeight:400}}>
                            {this.getNotes()}
                          </div>
                        </GridItem>
                      </GridContainer>
                  )
                },
              ]}
            />

          </DialogContent>
          
          <DialogActions
            className={classes.modalFooter }
            style={{backgroundColor:"#efefef"}}>
                <GridContainer style={{width:"100%"}}>
                    <GridItem xs={5} style={{textAlign:"left"}}>
                        <Button>
                            <Download onClick={() => this.downloadPDF()} />Download PDF
                        </Button>
                    </GridItem>
                    <GridItem xs={7}>
                        <CircularProgress className={classes.progress} color="secondary" 
                            style={{display:this.showSyncProgressIndicator(), marginRight:"23px"}} />

                        <div style={{display:this.showActionButtons()}}>
                            <Button onClick={() => this.handleClose("modal")} >
                            Close
                            </Button>
                            &nbsp;
                        </div>
                    </GridItem>
                </GridContainer>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return state;
}

OrderDetails = connect(mapStateToProps)(OrderDetails);
export default withStyles(modalStyle)(OrderDetails);


// WEBPACK FOOTER //
// ./src/components/OrderDetails/OrderDetails.jsx